import Typography from '@anwb/poncho/components/typography';
import styled from 'styled-components';

export const StyledTypography = styled(Typography)`
	margin-bottom: 0;
`;
